export const PREVIEW_DOCUMENT_PANO_WIDTH = 718;

export const PREVIEW_HEADER_WIDE_LOGO_ASPECT_RATIO = 4;
export const PREVIEW_HEADER_NAME_MAX_LINES = 3;
export const PREVIEW_HEADER_INLINE_LOGO_MAX_WIDTH_RATIO = 0.5;
